import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tag", "htmlFor", "style", "accessibilityTraits", "accessibilityRole", "accessibilityState", "onPress", "forwardLabel", "onRef"],
    _excluded2 = ["lineHeight", "transform"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { prefixStyle } from '@lada/prefix';
import defaultStyles from './defaultStyles';
import styleTransformArrayToText from './styleTransformArrayToText';

var View = function View(_ref) {
  var tag = _ref.tag,
      htmlFor = _ref.htmlFor,
      style = _ref.style,
      accessibilityTraits = _ref.accessibilityTraits,
      accessibilityRole = _ref.accessibilityRole,
      accessibilityState = _ref.accessibilityState,
      onPress = _ref.onPress,
      forwardLabel = _ref.forwardLabel,
      onRef = _ref.onRef,
      props = _objectWithoutProperties(_ref, _excluded);

  var mergedStyles = React.useMemo(function () {
    var _ref2 = style || {},
        lineHeight = _ref2.lineHeight,
        transform = _ref2.transform,
        restOfStyles = _objectWithoutProperties(_ref2, _excluded2); // @ts-expect-error


    return prefixStyle(_objectSpread(_objectSpread(_objectSpread({}, defaultStyles), restOfStyles), {}, {
      lineHeight: lineHeight && "".concat(lineHeight, "px"),
      transform: transform && styleTransformArrayToText(transform)
    }));
  }, [style]);

  switch (tag) {
    case 'label':
      {
        return /*#__PURE__*/React.createElement("label", {
          htmlFor: htmlFor
        }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
          ref: onRef,
          style: mergedStyles
        })));
      }

    default:
      {
        return /*#__PURE__*/React.createElement("div", _extends({}, props, {
          ref: onRef,
          style: mergedStyles
        }));
      }
  }
};

export default View;
//# sourceMappingURL=index.js.map